/* ULTENO Latte — interacciones propias (vanilla, sin librerías) */
(function () {
  'use strict';
  var reduce = window.matchMedia('(prefers-reduced-motion: reduce)').matches;
  var fine = window.matchMedia('(hover: hover) and (pointer: fine)').matches;

  /* ---------- Entradas al hacer scroll (un solo observer) ---------- */
  function initReveal(root) {
    var els = (root || document).querySelectorAll('.lt-reveal, .lt-mask, .lt-develop, [data-lt-reveal]');
    if (!els.length) return;
    if (reduce || !('IntersectionObserver' in window)) {
      els.forEach(function (el) { el.classList.add('lt-visible'); });
      return;
    }
    var io = new IntersectionObserver(function (entries) {
      entries.forEach(function (e) {
        if (e.isIntersecting) { e.target.classList.add('lt-visible'); io.unobserve(e.target); }
      });
    }, { rootMargin: '0px 0px -10% 0px', threshold: 0.08 });
    els.forEach(function (el) { io.observe(el); });
  }

  /* ---------- Parallax suave (solo transform) ---------- */
  var parallaxBound = false;
  function initParallax() {
    if (reduce || parallaxBound) return;
    parallaxBound = true;
    var ticking = false;
    function update() {
      var vh = window.innerHeight;
      document.querySelectorAll('[data-lt-parallax]').forEach(function (el) {
        var r = el.getBoundingClientRect();
        if (r.bottom < 0 || r.top > vh) return;
        var k = parseFloat(el.getAttribute('data-lt-parallax')) || 0;
        var progress = (r.top + r.height / 2 - vh / 2) / vh;
        el.style.setProperty('--lt-parallax', (progress * k * -1).toFixed(1) + 'px');
      });
      ticking = false;
    }
    window.addEventListener('scroll', function () { if (!ticking) { requestAnimationFrame(update); ticking = true; } }, { passive: true });
    update();
  }

  /* ---------- Hero: entrada con flash de cámara ---------- */
  function initHero() {
    document.querySelectorAll('.lt-hero').forEach(function (h) {
      requestAnimationFrame(function () { setTimeout(function () { h.classList.add('lt-loaded'); }, 60); });
      var badge = h.querySelector('.lt-hero__badge');
      if (badge && !badge.dataset.bound) {
        badge.dataset.bound = '1';
        badge.addEventListener('click', function (e) {
          var href = badge.getAttribute('href');
          if (reduce || !href) return;
          e.preventDefault();
          h.classList.remove('lt-loaded'); void h.offsetWidth; h.classList.add('lt-loaded');
          setTimeout(function () { window.location.href = href; }, 420);
        });
      }
    });
  }

  /* ---------- Muro: inclinación 3D al cursor ---------- */
  function initTilt(root) {
    if (reduce || !fine) return;
    (root || document).querySelectorAll('[data-lt-tilt]').forEach(function (card) {
      if (card.dataset.tiltBound) return;
      card.dataset.tiltBound = '1';
      var inner = card.querySelector('.lt-polaroid') || card;
      card.addEventListener('pointermove', function (e) {
        var r = card.getBoundingClientRect();
        var x = (e.clientX - r.left) / r.width - 0.5;
        var y = (e.clientY - r.top) / r.height - 0.5;
        inner.style.transform = 'rotateY(' + (x * 12).toFixed(2) + 'deg) rotateX(' + (y * -12).toFixed(2) + 'deg)';
      });
      card.addEventListener('pointerleave', function () { inner.style.transform = ''; });
    });
  }

  /* ---------- Selector de colores ---------- */
  function initColors(root) {
    (root || document).querySelectorAll('[data-lt-colors]').forEach(function (sec) {
      var sw = sec.querySelectorAll('.lt-swatch');
      var imgs = sec.querySelectorAll('.lt-colors__stage img');
      var name = sec.querySelector('.lt-colors__name');
      var btn = sec.querySelector('[data-lt-colors-btn]');
      var glow = sec.querySelector('.lt-colors__glow');
      var timer = null, idx = 0;
      function set(i) {
        idx = i;
        sw.forEach(function (s, j) { s.classList.toggle('is-active', j === i); s.setAttribute('aria-pressed', j === i ? 'true' : 'false'); });
        imgs.forEach(function (im, j) { im.classList.toggle('is-active', j === i); });
        var s = sw[i]; if (!s) return;
        if (name) name.textContent = s.getAttribute('data-label') || '';
        if (btn && s.getAttribute('data-url')) btn.setAttribute('href', s.getAttribute('data-url'));
        if (btn && s.getAttribute('data-btn')) { var t = btn.querySelector('[data-lt-btn-text]'); if (t) t.textContent = s.getAttribute('data-btn'); }
        if (glow) glow.style.setProperty('--glow', s.getAttribute('data-color'));
      }
      sw.forEach(function (s, i) { s.addEventListener('click', function () { stop(); set(i); }); });
      function stop() { if (timer) { clearInterval(timer); timer = null; } }
      var auto = parseInt(sec.getAttribute('data-auto'), 10) || 0;
      if (auto > 0 && !reduce && sw.length > 1 && 'IntersectionObserver' in window) {
        var io = new IntersectionObserver(function (en) {
          if (en[0].isIntersecting && !timer && sec.dataset.touched !== '1') timer = setInterval(function () { set((idx + 1) % sw.length); }, auto * 1000);
          else if (!en[0].isIntersecting) stop();
        }, { threshold: 0.4 });
        io.observe(sec);
        sec.addEventListener('pointerdown', function () { sec.dataset.touched = '1'; stop(); });
      }
      set(0);
    });
  }

  /* ---------- FAQ / acordeones con altura animada ---------- */
  function initAccordions(root) {
    (root || document).querySelectorAll('details[data-lt-acc]').forEach(function (d) {
      if (d.dataset.accBound) return;
      d.dataset.accBound = '1';
      var sum = d.querySelector('summary');
      var body = d.querySelector('[data-lt-acc-body]');
      if (!sum || !body || reduce) return;
      sum.addEventListener('click', function (e) {
        e.preventDefault();
        if (d.open) {
          var h = body.scrollHeight;
          body.animate([{ height: h + 'px', opacity: 1 }, { height: '0px', opacity: 0 }], { duration: 450, easing: 'cubic-bezier(0.22,1,0.36,1)' })
            .onfinish = function () { d.open = false; };
        } else {
          d.open = true;
          var h2 = body.scrollHeight;
          body.animate([{ height: '0px', opacity: 0 }, { height: h2 + 'px', opacity: 1 }], { duration: 550, easing: 'cubic-bezier(0.22,1,0.36,1)' });
        }
      });
    });
  }

  /* ---------- Página de producto ---------- */
  function initProduct(root0) {
    (root0 || document).querySelectorAll('[data-lt-pdp]').forEach(function (root) {
      if (root.dataset.pdpBound) return;
      root.dataset.pdpBound = '1';
      /* Galería */
      var slides = root.querySelectorAll('.lt-pdp__slide');
      var thumbs = root.querySelectorAll('.lt-pdp__thumb');
      var cur = 0;
      function go(i) {
        if (!slides.length) return;
        cur = (i + slides.length) % slides.length;
        slides.forEach(function (s, j) { s.classList.toggle('is-active', j === cur); });
        thumbs.forEach(function (t, j) { t.classList.toggle('is-active', j === cur); t.setAttribute('aria-current', j === cur ? 'true' : 'false'); });
        var at = thumbs[cur];
        if (at && at.parentNode && at.parentNode.scrollTo) {
          var p = at.parentNode;
          if (p.scrollWidth > p.clientWidth) p.scrollTo({ left: at.offsetLeft - p.clientWidth / 2 + at.clientWidth / 2, behavior: 'smooth' });
          else if (p.scrollHeight > p.clientHeight) p.scrollTo({ top: at.offsetTop - p.clientHeight / 2 + at.clientHeight / 2, behavior: 'smooth' });
        }
      }
      thumbs.forEach(function (t, i) { t.addEventListener('click', function () { go(i); }); });
      var prev = root.querySelector('[data-lt-prev]'), next = root.querySelector('[data-lt-next]');
      if (prev) prev.addEventListener('click', function () { go(cur - 1); });
      if (next) next.addEventListener('click', function () { go(cur + 1); });
      var main = root.querySelector('.lt-pdp__main');
      if (main) {
        var x0 = null;
        main.addEventListener('touchstart', function (e) { x0 = e.touches[0].clientX; }, { passive: true });
        main.addEventListener('touchend', function (e) {
          if (x0 === null) return;
          var dx = e.changedTouches[0].clientX - x0;
          if (Math.abs(dx) > 40) go(cur + (dx < 0 ? 1 : -1));
          x0 = null;
        });
      }

      /* Variantes */
      var dataEl = root.querySelector('[data-lt-variants]');
      var variants = dataEl ? JSON.parse(dataEl.textContent) : [];
      var form = root.querySelector('form[data-lt-form]');
      var idInput = form ? form.querySelector('input[name="id"]') : null;
      var addBtn = root.querySelector('.lt-pdp__add');
      var addLabel = addBtn ? addBtn.querySelector('[data-lt-add-label]') : null;
      var priceNow = root.querySelector('[data-lt-price]');
      var priceWas = root.querySelector('[data-lt-compare]');
      var saveEl = root.querySelector('[data-lt-save]');
      var stickyPrice = document.querySelector('[data-lt-sticky-price]');
      var moneyFmt = root.getAttribute('data-money-format') || '${{amount}}';
      var txtAdd = root.getAttribute('data-txt-add'), txtSold = root.getAttribute('data-txt-sold');
      var saveTpl = root.getAttribute('data-txt-save') || 'Save [amount]';
      function money(cents) {
        var v = (cents / 100).toFixed(2);
        return moneyFmt.replace(/\{\{\s*amount[a-z_]*\s*\}\}/, v.replace(/\B(?=(\d{3})+(?!\d))/g, ','));
      }
      function selected() {
        var opts = [];
        root.querySelectorAll('[data-lt-option]').forEach(function (fs) {
          var c = fs.querySelector('input:checked');
          opts.push(c ? c.value : null);
          var lab = fs.querySelector('[data-lt-option-value]');
          if (lab && c) lab.textContent = c.value;
        });
        return opts;
      }
      function onChange() {
        var opts = selected();
        var v = variants.find(function (x) { return x.options.every(function (o, i) { return o === opts[i]; }); });
        if (!v) return;
        if (idInput) idInput.value = v.id;
        if (priceNow) priceNow.textContent = money(v.price);
        if (stickyPrice) stickyPrice.textContent = money(v.price);
        var onSale = v.compare_at_price && v.compare_at_price > v.price;
        if (priceWas) { priceWas.textContent = onSale ? money(v.compare_at_price) : ''; priceWas.hidden = !onSale; }
        if (saveEl) { saveEl.hidden = !onSale; if (onSale) saveEl.textContent = saveTpl.replace('[amount]', money(v.compare_at_price - v.price)).replace('[percent]', Math.round((v.compare_at_price - v.price) * 100 / v.compare_at_price) + '%'); }
        if (addBtn) { addBtn.disabled = !v.available; if (addLabel) addLabel.textContent = v.available ? txtAdd : txtSold; }
        if (v.featured_media_index !== null && v.featured_media_index !== undefined) go(v.featured_media_index);
        var url = new URL(window.location.href); url.searchParams.set('variant', v.id);
        window.history.replaceState({}, '', url.toString());
      }
      root.querySelectorAll('[data-lt-option] input').forEach(function (i) { i.addEventListener('change', onChange); });

      /* Cantidad */
      var qty = root.querySelector('[data-lt-qty]');
      if (qty) {
        var input = qty.querySelector('input');
        qty.querySelectorAll('button').forEach(function (b) {
          b.addEventListener('click', function () {
            var n = parseInt(input.value, 10) || 1;
            n += b.getAttribute('data-step') === '-1' ? -1 : 1;
            input.value = Math.max(1, n);
          });
        });
      }

      /* Añadir al carrito con el cajón de Dawn */
      if (form) {
        form.addEventListener('submit', function (e) {
          var cart = document.querySelector('cart-drawer');
          if (!cart || typeof cart.renderContents !== 'function') return; /* sin cajón: envío normal */
          e.preventDefault();
          var msg = root.querySelector('.lt-pdp__msg');
          if (msg) msg.textContent = '';
          addBtn.classList.add('is-loading');
          var fd = new FormData(form);
          fd.append('sections', cart.getSectionsToRender().map(function (s) { return s.id; }));
          fd.append('sections_url', window.location.pathname);
          cart.setActiveElement(document.activeElement);
          fetch(window.routes.cart_add_url, { method: 'POST', headers: { 'X-Requested-With': 'XMLHttpRequest', Accept: 'application/javascript' }, body: fd })
            .then(function (r) { return r.json(); })
            .then(function (res) {
              if (res.status) { if (msg) msg.textContent = res.description || res.message; return; }
              cart.classList.remove('is-empty');
              cart.renderContents(res);
            })
            .catch(function () { form.submit(); })
            .finally(function () { addBtn.classList.remove('is-loading'); });
        });
      }

      /* Barra fija de compra en móvil */
      var sticky = document.querySelector('.lt-sticky-buy');
      if (sticky && addBtn && 'IntersectionObserver' in window) {
        var io = new IntersectionObserver(function (en) {
          var r = en[0].boundingClientRect;
          sticky.classList.toggle('is-shown', !en[0].isIntersecting && r.top < 0);
        });
        io.observe(addBtn);
        var sbtn = sticky.querySelector('button');
        if (sbtn) sbtn.addEventListener('click', function () { addBtn.click(); });
      }
    });
  }

  /* ---------- Oferta del carrito: pasar de 4 a 12 plantillas ---------- */
  document.addEventListener('click', function (e) {
    var btn = e.target.closest('[data-lt-upsell-btn]');
    if (!btn) return;
    var box = btn.closest('[data-lt-upsell]');
    var err = box.querySelector('.lt-upsell__err');
    var cart = document.querySelector('cart-drawer');
    var inDrawer = !!btn.closest('cart-drawer');
    btn.disabled = true; box.classList.add('is-loading');
    var json = { 'Content-Type': 'application/json', Accept: 'application/json' };
    var updates = {}; updates[box.dataset.key] = 0;
    fetch('/cart/update.js', { method: 'POST', headers: json, body: JSON.stringify({ updates: updates }) })
      .then(function (r) { if (!r.ok) throw new Error(); return r.json(); })
      .then(function () {
        var body = { items: [{ id: Number(box.dataset.variant), quantity: Number(box.dataset.qty) || 1 }] };
        if (inDrawer && cart) { body.sections = cart.getSectionsToRender().map(function (s) { return s.id; }); body.sections_url = window.location.pathname; }
        return fetch('/cart/add.js', { method: 'POST', headers: json, body: JSON.stringify(body) });
      })
      .then(function (r) { return r.json(); })
      .then(function (res) {
        if (res.status) throw new Error(res.description || res.message);
        if (inDrawer && cart && res.sections) { cart.renderContents(res); }
        else { window.location.reload(); }
      })
      .catch(function (ex) {
        if (err) err.textContent = (ex && ex.message) || 'Something went wrong. Please try again.';
        btn.disabled = false; box.classList.remove('is-loading');
      });
  });

  function init(root) {
    initHero(); initReveal(root); initParallax(); initTilt(root); initColors(root); initAccordions(root); initProduct(root);
  }
  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', function () { init(); }); else init();

  /* Editor de Shopify: re-inicializar al recargar una sección */
  document.addEventListener('shopify:section:load', function (e) { init(e.target); });
})();
